import { render, staticRenderFns } from "./gripButton.vue?vue&type=template&id=4173412a&"
import script from "./gripButton.vue?vue&type=script&lang=ts&"
export * from "./gripButton.vue?vue&type=script&lang=ts&"
import style0 from "./gripButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports